/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IHosportsSacFinderViewProps } from './hosports-sac-finder';

export default (props: IHosportsSacFinderViewProps) => {
    return (
        <h2>{'Sac Finder Page'}</h2>
    );
};
